import * as React from 'react';
import { SVGProps } from 'react';

const SvgMedicalRecordsOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <g clipPath="url(#a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4c1.306 0 2.418.835 2.83 2H16a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h4Zm4 4H8a2 2 0 0 0-1.995 1.85L6 10v6a2 2 0 0 0 1.85 1.994L8 18h8a2 2 0 0 0 1.994-1.85L18 16v-6a2 2 0 0 0-2-2Zm-4 2a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgMedicalRecordsOutlined;
